import { motion } from "framer-motion";

const CHAPTER_BG =
  "https://images.unsplash.com/photo-1768851142314-c4ebf49ad45b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBldmVudCUyMGdvbGR8ZW58MHx8fHwxNzkzMjU3Mzg4fDA&ixlib=rb-4.1.0&q=85";

export const NextChapter = () => (
  <section id="next-chapter" data-testid="next-chapter-section" className="relative overflow-hidden py-24 md:py-32">
    <div
      className="absolute inset-0 bg-cover bg-center bg-fixed"
      style={{ backgroundImage: `url(${CHAPTER_BG})` }}
    />
    <div className="absolute inset-0 bg-fira-deep/85" />
    <div className="relative z-10 mx-auto max-w-3xl px-5">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="rounded-3xl border border-fira-pink/30 bg-fira-deep/70 p-10 text-center backdrop-blur-xl md:p-14"
      >
        <span className="eyebrow">
          The Next Chapter
        </span>
        <h2 className="font-display mt-4 text-4xl font-semibold leading-tight md:text-5xl">
          Five Years Of Experience. <span className="italic text-fira-rose">What Comes Next?</span>
        </h2>
        <div className="mt-6 space-y-4 text-sm leading-relaxed text-white/70 md:text-base">
          <p>Sepanjang perjalanan sebagai trader, kita belajar pelbagai strategi, memahami market dan melalui bermacam-macam cabaran.</p>
          <p>Tetapi pengalaman sahaja tidak semestinya bermaksud kita semakin berkembang.</p>
          <p>Kadang-kadang, perubahan sebenar bermula apabila kita melihat semula cara kita berfikir, membuat keputusan dan memperbaiki diri.</p>
          <p>Fira Worldwide percaya bahawa perjalanan seorang trader tidak sepatutnya berhenti pada sekadar mencari entry.</p>
          <p className="font-display text-lg italic text-fira-rose">
            Because the next chapter is about growth, evolution and becoming a better trader.
          </p>
        </div>
        <div className="mx-auto mt-8 max-w-md space-y-3 text-left" data-testid="next-chapter-questions">
          {[
            "Apa yang bakal berubah?",
            "Apa yang Fira sedang bina untuk masa depan komuniti ini?",
            "Dan kenapa sekarang?",
          ].map((q) => (
            <p key={q} className="border-l-2 border-fira-pink/60 pl-4 text-sm italic text-white/80">
              {q}
            </p>
          ))}
        </div>
        <div className="mt-10 border-t border-white/10 pt-8">
          <p data-testid="next-chapter-reveal" className="text-sm font-bold uppercase tracking-[0.25em] text-white">
            All Will Be Revealed At The New Era
          </p>
          <p className="text-glow font-display mt-3 text-5xl font-bold italic text-fira-rose md:text-6xl">
            15.11.2026
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);
